import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TieredMenu, TieredMenuModule } from 'primeng/tieredmenu';

@Component({
  selector: 's-ui-tieredMenu',
  templateUrl: './s-ui-tieredMenu.component.html',
  styleUrls: ['./s-ui-tieredMenu.component.scss'],
  imports: [TieredMenuModule],
  standalone: true,

  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SUiTieredMenuComponent {
  @Input() menuItems: MenuItem[];
  @Input() popup = true;
  @ViewChild('menu', { static: false }) menu: TieredMenu;

  toggle($event) {
    this.menu.toggle($event);
    $event.stopPropagation();
    $event.preventDefault();
  }
}
